import { useState } from 'react';
import FormField from '../../components/FormField';
import { useAlert } from 'react-alert';
import { useNavigate } from 'react-router-dom';
import './styles/SignUp.scss'
import { ApiHelper } from '../../apiHelper/ApiHelper';
import InfoBanner from '../../components/InfoBanner';
import Seo from '../../components/Seo';

export default function SignUp() {
    const[name, setName] = useState("");
    const[surname, setSurname] = useState("");
    const[email, setEmail] = useState("");
    const[password, setPassword] = useState("");
    const[passwordRep, setPasswordRep] = useState("");
    const[confirmation, setConfirmation] = useState(false);
    // Keep the how-to closed by default so the form is immediately usable; the
    // user can open it on demand from the "Jak na to?" trigger below the title.
    const[banner, setBanner] = useState(false);
    const alert = useAlert();
    const navigate = useNavigate();

    const api = new ApiHelper();

    async function process() {
        if (password !== passwordRep) {
            alert.error("Hesla nejsou shodná");
            return;
        }

        if (!confirmation) {
            alert.error("Bez souhlasu se nelze registrovat");
            return;
        }

        try {
            await api.userApi.registerCreate({email: email, password: password, name: name, surname: surname});
            alert.success("Registrace proběhla úspěšně");
            alert.info("Před přihlášením je třeba ověřit email! Očekávejte ověřovací email ve Vaší mailové schránce. Může přijít až za půl hodiny od registrace. Pokud se tak nestane, kontaktujte nás.");
            navigate("/prihlaseni");
        } catch (x : any) {
            api.processErrors(x);
        }
    }

    return (
        <>
            <Seo title="Registrace" noindex />
            <div className="signUp">
                {banner &&
                    <InfoBanner title="Jak na to?" click={() => setBanner(false)}>
                        <div className="diagram">
                            <picture>
                                <source srcSet="/images/pages/diagrams/Diagram-mobil.webp" type="image/webp" />
                                <img src="/images/pages/diagrams/Diagram-mobil.png" alt="" />
                            </picture>
                        </div>
                    </InfoBanner>
                }

                <div className="container" >
                    <h1 className="title">
                        Registrace
                    </h1>

                    <span className="howto" onClick={() => setBanner(true)}>Jak to funguje? →</span>

                    <FormField label="jméno" value={name} handle={setName} />
                    <FormField label="příjmení" value={surname} handle={setSurname} />
                    <FormField label="email" value={email} handle={setEmail} />
                    <FormField label="heslo" value={password} handle={setPassword} password={true} />
                    <FormField label="heslo znovu" value={passwordRep} handle={setPasswordRep} password={true} />

                    <label className="conf">
                        <input type='checkbox' checked={confirmation} onChange={() => setConfirmation((c : any) => !c)} />
                        <h3>Souhlasím s obchodními podmínkami a podmínkami GDPR přístupnými na stránce níže</h3>
                    </label>

                    <div className={"button"} onClick={() => process()}>
                        <h2>
                            REGISTROVAT SE
                        </h2>
                    </div>
                </div>
            </div>
        </>
    );
}

